import React, { useState, createContext, useContext, ReactNode } from 'react';
type Language = 'en' | 'ur';
interface Translations {
  [key: string]: {
    en: string;
    ur: string;
  };
}
export const translations: Translations = {
  welcome: {
    en: 'Welcome, Kashish',
    ur: 'خوش آمدید، کشش'
  },
  manageAccount: {
    en: 'Manage your account today',
    ur: 'آج ہی اپنا اکاؤنٹ منظم کریں'
  },
  accountBalance: {
    en: 'Account Balance',
    ur: 'اکاؤنٹ بیلنس'
  },
  ibanNumber: {
    en: 'IBAN Number',
    ur: 'آئی بی اے این نمبر'
  },
  required: {
    en: 'Required',
    ur: 'ضروری'
  },
  completeBiometric: {
    en: 'Complete Biometric Verification',
    ur: 'بائیو میٹرک تصدیق مکمل کریں'
  },
  verifyIdentity: {
    en: 'Verify your identity with NADRA to unlock all features',
    ur: 'تمام خصوصیات کو غیر مقفل کرنے کے لیے نادرا سے اپنی شناخت کی تصدیق کریں'
  },
  sendMoney: {
    en: 'Send money',
    ur: 'پیسے بھیجیں'
  },
  billsPayments: {
    en: 'Bills & Payments',
    ur: 'بلز اور ادائیگیاں'
  },
  mobileTopup: {
    en: 'Mobile top-up',
    ur: 'موبائل ٹاپ اپ'
  },
  saveInvest: {
    en: 'Save & Invest',
    ur: 'بچت اور سرمایہ کاری'
  },
  quickActions: {
    en: 'Quick actions',
    ur: 'فوری اقدامات'
  },
  newAction: {
    en: 'New action',
    ur: 'نیا اقدام'
  },
  digiProducts: {
    en: 'Digi Products',
    ur: 'ڈیجی پروڈکٹس'
  },
  getDiscounts: {
    en: 'Get more Discounts!',
    ur: 'مزید رعایتیں حاصل کریں!'
  },
  useBop: {
    en: 'Use BOP for seamless transactions and better discounts',
    ur: 'ہموار لین دین اور بہتر رعایتوں کے لیے بی او پی استعمال کریں'
  },
  developedBy: {
    en: 'Developed by Tapsys',
    ur: 'ٹیپسس کے ذریعہ تیار کردہ'
  },
  accountSettings: {
    en: 'Account Settings',
    ur: 'اکاؤنٹ کی ترتیبات'
  },
  security: {
    en: 'Security',
    ur: 'سیکیورٹی'
  },
  notifications: {
    en: 'Notifications',
    ur: 'اطلاعات'
  },
  helpSupport: {
    en: 'Help & Support',
    ur: 'مدد اور تعاون'
  },
  about: {
    en: 'About',
    ur: 'کے بارے میں'
  },
  logout: {
    en: 'Logout',
    ur: 'لاگ آؤٹ'
  },
  language: {
    en: 'Language',
    ur: 'زبان'
  },
  appVersion: {
    en: 'App Version',
    ur: 'ایپ ورژن'
  },
  limitManagement: {
    en: 'Limit Management',
    ur: 'حد کا انتظام'
  },
  maintenanceCertificate: {
    en: 'Maintenance Certificate',
    ur: 'مینٹیننس سرٹیفکیٹ'
  },
  manageFinancing: {
    en: 'Manage Financing',
    ur: 'فنانسنگ کا انتظام'
  },
  otherBankCard: {
    en: 'Other Bank Card',
    ur: 'دوسرے بینک کا کارڈ'
  },
  paymentAuth: {
    en: 'Payment Authorization',
    ur: 'ادائیگی کی اجازت'
  },
  policyBriefcase: {
    en: 'Policy Briefcase',
    ur: 'پالیسی بریف کیس'
  },
  receiveRemittance: {
    en: 'Receive Remittance',
    ur: 'ترسیلات زر وصول کریں'
  },
  sendRemittance: {
    en: 'Send Remittance',
    ur: 'ترسیلات زر بھیجیں'
  },
  takafulClaims: {
    en: 'Takaful Claims',
    ur: 'تکافل کلیمز'
  }
};
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
  isRtl: boolean;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  const t = (key: string) => {
    if (!translations[key]) return key;
    return translations[key][language] || translations[key]['en'];
  };
  const isRtl = language === 'ur';
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    isRtl
  }} data-id="element-4136" data-mp="1nh42b8fdlo1e">
      <div dir={isRtl ? 'rtl' : 'ltr'} className={isRtl ? 'font-urdu' : ''} data-id="element-4137" data-mp="21894oia4ouff">
        {children}
      </div>
    </LanguageContext.Provider>;
}
export function useTranslation() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
}